module.exports = __webpack_public_path__ + "static/img/2023年历-10.4b7e377.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2023年历-10.jpg
// module id = e7bc
// module chunks = 3